<script setup lang="ts">
import { computed, ref } from 'vue';
import cloneDeep from 'lodash/cloneDeep';
import Checkbox from 'primevue/checkbox';

interface Props {
  seasonObject: object;
  seasonRules: Array<any>;
  seasonIndex: number;
  ruleChecked: object;
}
const props = defineProps<Props>();

const emits = defineEmits<{
  'update:seasonObject': [value: any];
  'update:ruleChecked': [value: any];
}>();

const seasonal = computed({
  get() {
    return props.seasonObject;
  },
  set(value) {
    emits('update:seasonObject', value);
  }
});

const ruleChecked = computed({
  get() {
    return props.ruleChecked;
  },
  set(value) {
    emits('update:ruleChecked', value);
  }
});

const ruleCheck = ref(cloneDeep(ruleChecked.value));
const checkRule = (ruleName: string, status) => {
  if (!status) {
    ruleCheck.value[ruleName] = -1;
    ruleChecked.value[ruleName] = cloneDeep(ruleCheck.value[ruleName]);
    return ruleCheck.value;
  } else {
    props.seasonRules?.forEach((obj, i) => {
      if (obj.applyRules[ruleName] === true) {
        ruleCheck.value[ruleName] = i;
      }
    });
    ruleChecked.value[ruleName] = ruleCheck.value[ruleName];
    return ruleCheck.value[ruleName];
  }
};
</script>

<template>
  <div class="seasonal-checkbox">
    <div class="flex flex-wrap justify-content-start gap-3">
      <div class="col-12 md:col-12 pl-0">{{ $t('management.package.apply_which_rules') }}</div>
      <div class="flex align-items-center">
        <Checkbox
          id="fbr"
          @change="checkRule('fbr', seasonal.applyRules.fbr)"
          :disabled="(ruleChecked['fbr'] != -1 && ruleChecked['fbr'] != seasonIndex) || seasonal.applyRules.fullRisk || seasonal.applyRules.preReg || seasonal.applyRules.sharedRisk"
          v-model="seasonal.applyRules.fbr"
          inputId="input-fbr"
          :binary="true"
        />
        <label for="input-fbr" class="ml-2 cursor-pointer"> {{ $t('management.package.fbr') }} </label>
      </div>
      <div class="flex align-items-center">
        <Checkbox
          id="full-risk"
          @change="checkRule('fullRisk', seasonal.applyRules.fullRisk)"
          :disabled="(ruleChecked['fullRisk'] != -1 && ruleChecked['fullRisk'] != seasonIndex) || seasonal.applyRules.fbr || seasonal.applyRules.preReg || seasonal.applyRules.sharedRisk"
          v-model="seasonal.applyRules.fullRisk"
          inputId="input-full-risk"
          :binary="true"
          :value="seasonal.applyRules.fullRisk"
        />
        <label for="input-full-risk" class="ml-2 cursor-pointer"> {{ $t('management.package.full_risk') }} </label>
      </div>
      <div class="flex align-items-center">
        <Checkbox
          id="pre-reg"
          @change="checkRule('preReg', seasonal.applyRules.preReg)"
          :disabled="(ruleChecked['preReg'] != -1 && ruleChecked['preReg'] != seasonIndex) || seasonal.applyRules.fbr || seasonal.applyRules.fullRisk || seasonal.applyRules.sharedRisk"
          v-model="seasonal.applyRules.preReg"
          inputId="input-pre-reg"
          :binary="true"
          :value="seasonal.applyRules.preReg"
        />
        <label for="input-pre-reg" class="ml-2 cursor-pointer"> {{ $t('management.package.pre_reg') }} </label>
      </div>
      <div class="flex align-items-center">
        <Checkbox
          id="shared-risk"
          @change="checkRule('sharedRisk', seasonal.applyRules.sharedRisk)"
          :disabled="(ruleChecked['sharedRisk'] != -1 && ruleChecked['sharedRisk'] != seasonIndex) || seasonal.applyRules.fbr || seasonal.applyRules.fullRisk || seasonal.applyRules.preReg"
          v-model="seasonal.applyRules.sharedRisk"
          inputId="input-shared-risk"
          :binary="true"
          :value="seasonal.applyRules.sharedRisk"
        />
        <label for="input-shared-risk" class="ml-2 cursor-pointer"> {{ $t('management.package.share_risk') }} </label>
      </div>
    </div>
  </div>
</template>
